function getJobFields() { 
    return [
        {
            key: true,
            name: "sandbox_name",
            label: "Sandbox",
            type: "select",
            editable: true,  
            validation: [
                { type: "required"},
            ]         
        },
        {
            key: true,
            name: "name",
            label: "Name",
            type: "text",
            editable: true,           
            validation: [
                { type: "required"},
                {type: "regex", pattern:"^[a-z0-9-]*$",
                errMsg:"Job name only supports lowercase letters, numbers and dashes."}
            ],
            helpText: `<p><a href="https://help.aqfer.net/lakeview-api/job-naming-convention?from_search=129606375" target="_blank">Click here to view Naming Convention rules</a></p>`
        },
        {
            name: "kind",
            label: "Kind",
            visible: true,
            type: "text",
            editable: false,
            defaultValue:"TRANSFORM"
        }

    ];
}

export default getJobFields;

